import React, { useState } from "react";
import { defaultLogo } from "../../../env";
import { SideNav } from "../../../assets/Icons";
import { logOut } from "../../utils/operation";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { removeUser } from "../../../store/slice/userSlice";

const Header = ({ sideBar, setSideBar }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector(state => state.userSlice);
  const configData = useSelector((state) => state.configSlice);


  const logOut = async() =>{
    try {
        localStorage.clear();
        sessionStorage.clear();
        dispatch(removeUser());
        await axios.post(`${configData.config.UNO_URL}/api/auth/logout`, {}, {
            headers: {
                Authorization: `Bearer ${userData?.token}`,
            },
        });
        
    } catch (error) {
        console.log(error);
    }finally{
        navigate("/login")
    }

}

  return (
    <header>
      <div className="sidetoggle">
        <div
          className={sideBar ? "ps-1 activebar sidesvgdiv" : " sidesvgdiv ps-1"}
          onClick={() => {
            setSideBar(!sideBar)
            if (sideBar) {
              document.body.classList.add("body-lock");
            } else {
              document.body.classList.remove("body-lock");
            }
          }}
          style={{ width: "25px", height: "25px" }}
        >
          <SideNav />
        </div>
        <div className="mainlogo LOGOHERE">
          <img
            src={defaultLogo}
            onError={(e) => {
              e.target.src = defaultLogo;
              e.onerror = null;
            }}
            referrerPolicy={"no-referrer"}
            alt="Static Logo"
          />
          <p>Simulanis ModuleVault</p>
        </div>
      </div>

      <div className="leftmain">
        <div className="profile">
          <div className="dropdown profileavatar">
            <p className="d-none d-md-block">{userData.user.name}</p>
            <button
              className="btn btn-secondary dropdown-toggle themetoggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <div className="useravatar">
                <div className="avatar-placeholder">{userData?.user?.name?.split(" ")?.slice(0,2)?.map(e => e?.charAt(0)?.toUpperCase())?.join("") || ""}</div> 
              </div>
            </button>
            <div className="dropdown-menu themehere popupon">
              <div className="profilemenuhead" tabIndex="0">
                <div className="avatar-placeholder">{userData?.user?.name?.split(" ")?.slice(0,2)?.map(e => e?.charAt(0)?.toUpperCase())?.join("") ||  ""}</div>
                <div className="profilemenudata">
                  <p>{userData.user.name}</p>
                  <p>{userData.user.email}</p>
                </div>
              </div>
              <p className="logoutbtn" onClick={logOut}>
                Log out
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
